// src/components/ui/EmptyState/EmptyState.jsx
import React from "react"
import PropTypes from "prop-types"
import { Inbox } from "../Icon"
import { cn } from "../../../lib/utils"

const EmptyState = ({ title, className }) => {
  return (
    <output
      className={cn(
        "flex flex-col items-center justify-center gap-3 p-12 text-[var(--gray-9)]",
        className
      )}
      aria-label={title || "Nothing here"}
    >
      <Inbox
        size={32}
        className="text-[var(--gray-7)]"
        aria-hidden="true"
      />
      <span>{title || "Nothing here"}</span>
    </output>
  )
}

EmptyState.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
}

export default EmptyState
